//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {  useNavigate } from "react-router-dom";
import styled from "styled-components";
import COLOR from "utils/constants/color";

//  -- Features -----------------------

//  -- Thunks -------------------------
import { CaretDownOutlined } from '@ant-design/icons';
import * as Sentry from '@sentry/react';
import { Dropdown } from 'antd';
import SpinLoader from "components/Loader/SpinLoader";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import ChapterManagementBook from "features/ChapterManagementBook";
import { get } from "lodash";
import {  useCurrentOrgPermission } from "store/organizations/selectors";
import { useUserBook } from 'store/userBooks/selectors';
import { handleListUserBooksForDist } from 'store/userBooks/thunks';
import { useCurrentUser } from 'store/users/selectors';
const MENU = [
  { id: "ebook_list", value: "Ebooks" },
  { id:'informate', value: "1nformate"},
  { id:'resources', value: "1WayResources"},
  { id:'OneWayLessons', value: "1WayLessons"},
  { id:'story-levels', value: "1WayStory"}
];


const Wrapper = styled.div`
  height: 100%;
  padding: 0px 0px;
  width: 100%;
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-direction: row;
//   justify-content: space-between;
  width: 100%;
  min-height: 80px;
  border-radius: 12px;
//   border: 2px solid ${COLOR.black100};
//   background-color: ${COLOR.blueish400};
  margin-top: ${(p) => (p.top ? p.top : "50px")};
  align-items: center;
  position: relative;
  padding: 2px 0px;
  flex-wrap: wrap;
`;
const MenuBtn = styled.button`
  background-color:white;
  border-top:none;
  border-left:none;
  border-right:none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  outline: none;
  transition: all 300ms ease;
  padding: 2px 16px 10px 16px;
  margin-right: 2px;
  margin-left: 2px;
  @media (max-width: 992px) {
    margin-top: 10px;
  }
`;
const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
export default function Ebooklist({}) {
  const showAlert = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dataTab,setDataTab] = useState("ebook_list");
  const [loading, setLoading] = useState(false);
  const currentUser = useCurrentUser();
  const userBook = useUserBook()
  const orgPermissions = useCurrentOrgPermission()

  async function listExam(){
    const is_loading = !(userBook && userBook.books_group && userBook?.books_group?.length)
    setLoading(is_loading);
    try {
      await dispatch(handleListUserBooksForDist(currentUser.id))
    } catch (error) {
      Sentry.captureException(`429 Error in listExam: ${error}`);
      console.error(error,"error in loading placement exam")
    } finally{
      setLoading(false);
    }
  }
  useEffect(() => {
    async function fetchData() {
      try {
        const is_loading = !(userBook && userBook.books_group && userBook?.books_group?.length)
        setLoading(is_loading);
        await getCurrentUser();
        await listExam()
        setLoading(false);
      } catch(e) {
        Sentry.captureException(`430 Error in fetchData: ${e}`);
        console.log(e, "error in loading ebooks")
        setLoading(false);
        navigate("/");
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const onClick = (id) =>{
    switch(id){
      case "ebook_list":
         setDataTab(id)
      break;
      case "OneWayLessons":
        navigate("/OneWayLessons");
      break;
      case "resources":
        navigate("/resources");
      break;
      case "story-levels":
        navigate("/story-levels");
      break;
      case"informate":
        navigate("/informate");
      break;
      case 'exams':
        navigate("/exams");
      break;
      case 'standard-based-exam':
        navigate("/standard-based-exam");
      break;


    }
  }


const apNav = () => {
  return {
    items: [
      {
        key: 'ap_spanish_language',
        label: (
          <PaddedBtn onClick={() => {
              navigate('/ap?id=69')
              // onCloseMenuBook()
          }}>
              AP Spanish Language and Culture
          </PaddedBtn>
        ),
        style: { padding: '0px' }
      },
      {
        key: 'ap_spanish_literature',
        label: (
          <PaddedBtn onClick={() => {
              showAlert("Coming Soon", "info");
              return;
              navigate('/ap?id=69')
              // onCloseMenuBook()
          }}>
              AP Spanish Literature and Culture
          </PaddedBtn>
        ),
        style: { padding: '0px' }
      }
    ]
  };
};

const hasPermission = (key) =>{
  switch(key){
    case 'resources':
      return get(orgPermissions, '1WAYRESOURCES', true) 
    case 'story-levels':
      return  get(orgPermissions, '1WAYSTORY', true)
    case 'informate':
      return  get(orgPermissions, '1nformate', true)
    case 'exams':
      return  get(orgPermissions, 'exams', true)
    case 'standard-based-exam':
      return  get(orgPermissions, 'standard-based-exam', true)
    default:
      return true
  }
}
  return (
    <SentryWrap>
      <SpinLoader dataloader={loading} />
      <Wrapper className={"adminForm ebooksListTab"}>
        <MenuWrapper top={"10px"} style={{ width: "100%" }}>
          {MENU.map((x) => {
            if(!hasPermission(x.id)) return null
            return(
            <MenuBtn
              style={{
                borderBottom:
                  dataTab === x?.id
                    ? "5px solid rgb(28,49,115)"
                    : "5px solid #fcfcfc",
                color: dataTab === x?.id ? "rgb(28,49,115)" : "black",
              }}
              key={x.id}
              onClick={() => { onClick(x.id) }}
            >
              {x.value}
            </MenuBtn>
          )})}
          {get(orgPermissions, 'ap', true) ? <Dropdown menu={apNav()} placement="bottomLeft" trigger={['click']}>
            <MenuBtn onClick={e => e.preventDefault()} style={{ borderBottom: "5px solid #fcfcfc", color: "black" }}>
              AP   <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
            </MenuBtn>
          </Dropdown> : null}
          {get(orgPermissions, 'exams', true) ?
            <MenuBtn  onClick={e =>onClick("exams") } style={{ borderBottom: "5px solid #fcfcfc", color: "black" }}>
              Exams  
            </MenuBtn> : null}
            {get(orgPermissions, 'exams', true) ?
            <MenuBtn  onClick={e =>onClick("standard-based-exam") } style={{ borderBottom: "5px solid #fcfcfc", color: "black" }}>
              Standard Based Exams  
            </MenuBtn> : null}
        </MenuWrapper>
      
        {dataTab == MENU[0].id ? <ChapterManagementBook  org_books_group={userBook?.books_group||[]}/> : null}
      </Wrapper>
    </SentryWrap>
  )
}
